// @flow

import React from 'react'
import type { Node } from 'react'
import cx from 'classnames'

type Props = {
  children: Node,
  className?: string,
}

const style = {
  base: 'pt2 pb2',
}

const PostGroup = ({ children, className }: Props) => (
  <section className={cx(style.base, className)}>{children}</section>
)
PostGroup.defaultProps = {
  className: '',
}

export default PostGroup



// WEBPACK FOOTER //
// ./src/scenes/feed/post-group/post-group.js